import { SAMPLE_QUOTE } from './sampleQuote';

export const PAYMENT_CONFIRMATION_SAMPLE = {
  quote: SAMPLE_QUOTE,
  selectedBidOption: SAMPLE_QUOTE.bid_items[0].bid.bid_options[0],
  paymentResult: {
    transactionId: 'txn_abc123',
    reference: '12AB-34CD-56EF',
    totalAmount: 42205.15,
    amount: 38070,
    fees: [{ name: 'Credit Card Fee', amount: 1688.21, type: 'card_fee' }],
    paymentMethod: { brand: 'VISA', last4: '3456' },
  },
  bookingNumber: '12AB-34CD-56EF',
};
